import { Module } from "vuex";
import { MetadataMaskyooStatus } from "@/models/MetadataMaskyooStatus";
import { PhoneStatus } from "@/models/phones/PhoneWithChannel";
import { PhonesState } from "@/models/states/PhonesState";
import { RootState } from "@/models/states/RootState";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { RefreshGridMode } from "@/models/leads/Lead";

const leadsModule: Module<PhonesState, RootState> = {
  namespaced: true,
  state: {
    needToRefreshPhonesGrid: RefreshGridMode.None,
    page: 1,
    searchValue: "",
    selectedCallStatus: MetadataMaskyooStatus.All,
    selectedPhoneStatus: PhoneStatus.Active,
    showGraphs: true,
    sortDir: "desc",
    sortField: "CreateDate",
    cancelTokenSource: undefined,
    columnsFilters: undefined,
    phoneLeadStats: {
      CallsStatByDate: [],
      PhoneStats: []
    },
    phones: {},
    phonesPageData: {},
    selectedPhone: undefined,
    tableSettings: undefined,
    channels: [],
    companies: [],
    columns: [],
    datePeriod: [],
    selectedChannelMetadataTypesIds: [],
    selectedCompaniesIds: [],
    selectedPhonesGridColumnsIds: [],
    selectedSourcesIds: [],
    sources: []
  },
  getters,
  mutations,
  actions,
};
export default leadsModule;
